var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarFilterSelectedIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 16,
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.1204 1.36955C17.0236 1.14729 16.8633 0.95822 16.6593 0.825844C16.4553 0.693468 16.2166 0.623632 15.973 0.62502H2.14164C1.89828 0.625497 1.66029 0.696169 1.45653 0.828463C1.25278 0.960757 1.09203 1.14899 0.993767 1.37032C0.895508 1.59165 0.863969 1.83658 0.902977 2.07538C0.941985 2.31418 1.04986 2.53659 1.21352 2.71565L1.21981 2.72268L6.54253 8.37268V14.375C6.54247 14.6013 6.60418 14.8233 6.72107 15.0174C6.83796 15.2115 7.00565 15.3704 7.20626 15.4772C7.40688 15.584 7.63288 15.6347 7.86019 15.6239C8.0875 15.613 8.30759 15.5411 8.49699 15.4156L11.0118 13.7485C11.1842 13.6343 11.3255 13.4796 11.4233 13.298C11.521 13.1165 11.5722 12.9137 11.5721 12.7078V8.37268L16.8956 2.72268L16.9019 2.71565C17.0673 2.53741 17.1762 2.3147 17.2151 2.07531C17.2539 1.83592 17.221 1.59045 17.1204 1.36955ZM10.486 7.70158C10.3773 7.81621 10.3161 7.96745 10.3147 8.12502V12.7078L7.79992 14.375V8.12502C7.79997 7.96631 7.73928 7.81353 7.63017 7.69768L2.14164 1.87502H15.973L10.486 7.70158Z",
  fill: "#08B758"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarFilterSelectedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_filter_selected_icon.6344dcc3279531a3c52373f9f06170f5.svg";